import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getTopBanner, ITopBanner } from "api/commonApi";
import BnToggle from "./BnToggle";
import { useRecoilValue } from "recoil";
import { redirectURL } from "utils/CommonFunc";
import { isLauncherState } from "recoil/userInfoAtom";
import { langCodeState } from "recoil/commonUiAtom";
import { useLocation } from "react-router-dom";

function TopBanner() {
  const location = useLocation();
  const { isLoading, data, isError } = useQuery<ITopBanner>(
    ["topbanner"],
    getTopBanner,
    {
      enabled: !(location.pathname.split("/")[1] === "profile")
    }
  );

  const [isVeiw, setIsVeiw] = useState(true);
  const bannerRef = useRef<any>(null);
  const onClickPrevcomming = () => bannerRef.current.slickPrev();
  const onClickNextcomming = () => bannerRef.current.slickNext();
  const [isShowBanner, setisShowBanner] = useState(false);
  const langCode = useRecoilValue(langCodeState);
  const [bannerlang, setBannerlang] = useState("");
  const isLauncher = useRecoilValue(isLauncherState);

  const compareDate = (start: any, end: any) => {
    let startDate = new Date(start).getTime();
    let endDate = new Date(end).getTime();

    let todayDate = new Date().getTime();

    if (startDate <= todayDate && endDate > todayDate) {
      return true;
    }
    return false;
  };


  useEffect(() => {
    if (data?.result === 1) {
      let endDateArr = [];
      let startDateArr = [];
      for (let i = 0; i < data.data.length; i++) {
        endDateArr.push(new Date(data.data[i].end_date).getTime());
        startDateArr.push(new Date(data.data[i].start_date).getTime());
      }
      // 가장 큰 값은 가장 최근 값
      // 배너 리스트의 끝나는 시간들 중 가장 최근 값이 현재의 시간보다 작다면 top banner 자체를 내려야 한다.
      let endResult = endDateArr.reduce((prev, curr) =>
        prev <= curr ? curr : prev
      );
      // 가장 작은 값 가장 먼저 시작하는 값
      let startResult = Math.min(...startDateArr);

      if (
        endResult < new Date().getTime() ||
        startResult > new Date().getTime()
      ) {
        setisShowBanner(false);
      } else {
        setisShowBanner(true);
      }
    }
  }, [isLoading, bannerlang]);

  const settings = {
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    speed: 500,
    draggable: false,
    arrows: false,
    vertical: true,
    slidesToScroll: 1,
    verticalSwiping: true
  };

  return !isLoading && !isError ? (
    data?.result === 1 ? (
      bannerlang === langCode ? (
        isShowBanner ? (
          <BannerWrap>
            {isVeiw && (
              <div className="bn-wrap">
                <div className="arrow">
                  <div className="btns">
                    <button className="up" onClick={onClickPrevcomming} />
                    <span></span>
                    <button className="down" onClick={onClickNextcomming} />
                  </div>
                </div>

                <Slider {...settings} ref={bannerRef}>
                  {data?.data.map((i, idx) =>
                    compareDate(i.start_date, i.end_date) ? (
                      <div className="cont" key={idx}>
                        <div className="desc">
                          {Object.values(i.text).map((text: any, idx) => (
                            <div key={idx}>{text}</div>
                          ))}
                        </div>
                        <div className="bn-img">
                          <img
                            src={i.banner_image_url}
                            onClick={() =>
                              redirectURL(i.target_url, i.target, isLauncher)
                            }
                          />
                        </div>
                      </div>
                    ) : null
                  )}
                </Slider>
                <i onClick={() => setIsVeiw(false)} />
              </div>
            )}

            {!isVeiw ? <BnToggle setIsVeiw={setIsVeiw} /> : null}
          </BannerWrap>
        ) : null
      ) : null
    ) : null
  ) : null;
}

export default TopBanner;

const BannerWrap = styled.div`
  display: flex;
  justify-content: end;

  .bn-wrap {
    background-color: #33363f;
    width: 100%;
    display: flex;
    border-radius: 0.5rem;
    align-items: center;
    position: relative;

    .arrow {
      button {
        display: block;
        min-width: auto;
        height: auto;
        background-color: inherit;
        margin-bottom: 0;
        width: 12px;
        height: 8px;
        padding: 0;
      }

      .btns {
        padding: 0 1.25rem;

        span {
          display: block;
          margin: 10px 0;
          width: 12px;
          height: 0.063rem;
          background: #56585d;
        }

        .up {
          background-image: url(//file.valofe.com/Valofe_file/web/vfun/images/vfun_lounge/images/icon-angle-up.png);
          background-repeat: no-repeat;
        }

        .down {
          background-image: url(//file.valofe.com/Valofe_file/web/vfun/images/vfun_lounge/images/icon-angle-down.png);
          background-repeat: no-repeat;
        }
      }
    }
    .cont {
      width: 100%;
      display: flex !important;
      justify-content: space-between;

      .bn-img {
        width: calc(100% - 420px);
        margin-top: 8px;
        margin-right: 12px;
        margin: 8px 12px 8px 1rem;

        img {
          width: 100%;
          cursor: pointer;
        }
      }

      .desc {
        display: inline-block;
        color: #fff;
        font-size: 0.875rem;
        height: 100%;
        width: 420px;
        line-height: 1.5;
        top: 0;
        bottom: 0;
        margin: auto 0;
      }
    }

    .slick-slider {
      width: 100%;

      .slick-track {
        height: auto !important;

        .slick-slide {
          width: 100% !important;
        }
      }
    }

    i {
      background-image: url(//file.valofe.com/Valofe_file/web/vfun/images/vfun_lounge/images/icon-x.png);
      background-repeat: no-repeat;
      position: absolute;
      width: 15px;
      height: 14px;
      top: 16px;
      right: 18px;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 1200px) {
    .bn-wrap {
      .cont {
        .bn-img {
          width: calc(60% - 1rem);
        }

        .desc {
          width: 40%;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .bn-wrap {
      .cont {
        .bn-img {
          width: calc(70% - 1rem);
        }

        .desc {
          width: 30%;
          font-size: 0.75rem;
        }
      }
    }
  }

  @media screen and (max-width: 940px) {
    .bn-wrap {
      .cont {
        .bn-img {
          width: calc(75% - 1rem);
        }

        .desc {
          width: 25%;
          font-size: 0.75rem;
        }
      }
    }
  }

  @media screen and (max-width: 680px) {
    .bn-wrap {
      .cont {
        .bn-img {
          /* width: calc(75% - 1rem); */
          width: 100%;
          margin-left: 0px;
        }

        .desc {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 414px) {
    .bn-wrap .arrow .btns {
      padding: 0px 0.75rem;
    }
  }
`;
